import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { Contact } from "src/app/models/contact.model";
import { GraphService, ColumnMapEntry } from './graph.service';
import { ResourceNames } from "./resource-names";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: 'root'
})
export class GraphContactService {

	constructor(
		private readonly graphService: GraphService
	) { }


	static readonly listTitle = ResourceNames.CONTACT_US_LIST_NAME;
	static readonly columnMap: ReadonlyArray<ColumnMapEntry<Contact>> = [
		{ modelKey: "categoryCode", spFriendlyFieldName: "Section" },
		{ modelKey: "message", spFriendlyFieldName: "Comment" },
		{ modelKey: "id", spFriendlyFieldName: "Id" },
		{ modelKey: "title", spFriendlyFieldName: "Title" },
	];

	public submit(contact: Contact): Observable<string> {
		const spContact = this.convertToSpFriendlyItem(contact)

		return this.graphService.addListItem(GraphContactService.listTitle, spContact).pipe(
			map((id: number) => this.generateFeedbackReferenceId(id))
		);
	}

	private convertToSpFriendlyItem(contact: Contact) {
		let item = {};
		GraphContactService.columnMap.map(prop => {
			const spProperty = prop.spFriendlyFieldName;
			const contactProperty = contact[prop.modelKey];
			if (!Array.isArray(spProperty) && contactProperty) {
				item[spProperty] = contactProperty;
			}
		});
		return item;
	}

	private generateFeedbackReferenceId(id: number): string {
		const environmentId = environment.name === 'production' ? '' : `${environment.name}-`;
		return `#REF-${environmentId}${String(id).padStart(4, '0')}`;
	}
}